export default __webpack_public_path__ + "static/media/easilys.0e86a033.jpg";